import './../styles/main.scss'; 
import { browserSupportsAllFeatures } from './test';
import { isDefined } from './partials/helpers';
import { triggerRevealScroll } from './partials/scroll-reveal';
import { initHeader } from './partials/header';
import { preloadTransition } from './partials/preload-transition';
import { initPartner } from './partials/partner';
import { initLazyloadVideo } from './partials/lazyload';

if (module.hot) {
    module.hot.accept();
}

window.addEventListener('DOMContentLoaded', function() {
    
    if (!browserSupportsAllFeatures()) {
        // Require 'promise' for Parcel, then dynamic import polyfills.
        require('core-js/es/promise');
        import('./polyfill')
            .then(() =>
                console.log('Polyfills loaded... instantiate UI modules...')
            )
            .catch((e) => console.error(e));
    }

    if('IntersectionObserver' in window)
    {
        document.documentElement.classList.add('reveal-loaded')
        triggerRevealScroll();
    }

    initLazyloadVideo();
    initHeader();

    setTimeout(function() {
        preloadTransition();
    }, 100);

    initPartner();
})